<template>
    <div class="company-info" @click="goShopEvent" >
        <div class="company-info-title">
            {{obj.company.companyname}}
        </div>

        <div class="name-pad_img-box" >
            <img style="object-fit: contain;"  v-if="null != imgUrl" :src="imgUrl">
        </div>

        <div class="shop-info">
            <div class="company-info-content ">
                {{obj.addinfo16}}
            </div>


        </div>
    </div>
</template>

<script setup>

import {inject, computed, getCurrentInstance} from "vue";

    let { proxy } = getCurrentInstance();
    const emits = defineEmits(['click-go-shop'])
    const props = defineProps(['obj'])

    const i18n = inject("i18n")

    const { phoneGoFloorCallback } = inject('threeHallFunc', { phoneGoFloorCallback: () => {} })

    const imgUrl = computed(() => {
        let url = null
        if (null != props.obj && null != props.obj.company){
           // const json = JSON.parse(props.obj.addinfo12)
          const tssd = `${proxy.$SSL}://${props.obj.company.currentcapital}/MPIC/${props.obj.company.acccompanycode}/zz/zzComLogo.jpg`
            // if(null != json.img1){
            //     url = json.img1
            // }else if(null != json.img0){
            //   url = json.img0
            // }
          url = tssd
        }

        return url
    })

    function goShopEvent() {
        emits("click-go-shop", props.obj)
    }
</script>

<style scoped>
    .company-info {
        //border-bottom: 1px #d9d9d9 solid;
        line-height: 2;
        //padding-top: 10px;
        //padding-bottom: 10px;
        border: 1px #DCDFE6 solid;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
    }

    .company-info:nth-child(even) {
        background: #f9f9f9;
    }

    .company-info-title {
        text-align: left;
      font-weight: 600;
    }
    .company-info-content {
      text-align: left;
      font-size: 12px;
      -webkit-line-clamp: 2;
      width: 100%;
    }


    .shop-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .name-pad_img-box{
        width: 100%;
        padding-top: 130%;
        position: relative;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .name-pad_img-box img{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: fill;
    }
</style>